import React, { Component } from "react";
import FadeIn from 'react-fade-in';
import { connect } from "react-redux";
import { Collapse, Nav, Navbar, NavItem, NavLink } from "reactstrap";
import UIDucks from "stores/ducks/UI.duck";
import "./style.css";
interface INavBarProps {
  leftItems?: any[];
  rightItems?: any[];
  sticky?: boolean;
  noWrapItems?: boolean;
  dark?: boolean;
  color?: string;
  dispatch?: any;
  isOpened: boolean;
}

class NavBar extends Component<INavBarProps> {
  constructor(props) {
    super(props);
    this.toggleNavBar = this.toggleNavBar.bind(this);
  }
  public toggleNavBar(e?: any) {
    this.props.dispatch(UIDucks.setNavBar(!this.props.isOpened));
  }

  public wrapNavItem(item) {
    if (this.props.noWrapItems) {
      return item;
    }
    return (
      <NavItem>
        <NavLink to="#" key="item">
          {item}
        </NavLink>
      </NavItem>
    );
  }

  public render() {
    const { props } = this;

    return (
      <FadeIn delay="200" transitionDuration="500">
      
      <Navbar
        color={props.dark ? "dark" : "light"}
        light={props.dark ? true : false}
        dark={props.dark ? false : true}
        expand="md"
        className={[props.sticky ? "navbar-secondary--sticky" : ""].join(" ")}
      >
        <div className="container">
        <button
          className={
            this.props.isOpened
              ? "navbar-toggler navbar-toggler-right f-right"
              : " navbar-toggler navbar-toggler-right collapsed"
          }
          type="button"
          data-toggle="collapse"
          data-target="#collapsingNavbar"
          onClick={this.toggleNavBar}
        >
          <span className="text-faded">Tap for more</span>
        </button>
        <button
          className={
            this.props.isOpened
              ? "navbar-toggler animated-burger ml-auto navbar-toggler-right f-right"
              : " navbar-toggler animated-burger ml-auto navbar-toggler-right collapsed"
          }
          type="button"
          data-toggle="collapse"
          data-target="#collapsingNavbar"
          onClick={this.toggleNavBar}
        >
          <span />
          <span /> 
          <span />
        </button>
        <Collapse isOpen={props.isOpened} navbar={true}>
          {/* Left Items */}
          <Nav className="ml-0" navbar={true}>
            {props.leftItems
              ? props.leftItems.map(item => this.wrapNavItem(item))
              : null}
          </Nav>
          {/* Right Items */}
          <Nav className="ml-auto" navbar={true}>
            {props.rightItems
              ? props.rightItems.map(item => this.wrapNavItem(item))
              : null}
          </Nav>
        </Collapse>
        </div>
      </Navbar>
      
      </FadeIn>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOpened: UIDucks.getIsNavBarOpen(state)
  };
};

export default connect(mapStateToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/NavBar.tsx